import { useSettings } from "~/store/settings";
import { getDNSSuffix } from "~/utils/getDNSSuffix";
import signalRConnection from "~/utils/signalr/signalRConnection";

export default defineNuxtPlugin(async (nuxtApp) => {
	const store = useSettings();

	const { signalrSports, signalrSportsRadar } = nuxtApp.$config.public;
	const route = useRoute();
	const isTrackRacing = computed(() => {
		return ["greyhounds", "horse-racing"].includes(route.params.sportId as string);
	});

	const isLobby = computed(() => {
		return route.path.includes("lobby");
	});

	const isHomepage = computed(() => route.path === "/");
	const {
		signalR: sportsSignalR,
		start: startSports,
		stop: stopSports,
	} = signalRConnection({
		url: getDNSSuffix(store.isRadarEnabled ? signalrSportsRadar : signalrSports) + "/synapse-hub",
		id: "Sports",
	});

	const {
		signalR: trackRacingSignalR,
		start: startTrackRacing,
		stop: stopTrackRacing,
	} = signalRConnection({
		url: getDNSSuffix(signalrSports) + "/synapse-hub",
		id: "TrackRacing",
	});

	watchEffect(() => {
		if (!isLobby.value && !isHomepage.value && sportsSignalR.state !== "Connected") {
			startSports();
		} else if ((isLobby.value || isHomepage.value) && sportsSignalR.state === "Connected") {
			stopSports();
		}
	});

	watchEffect(() => {
		if (isTrackRacing.value && trackRacingSignalR.state !== "Connected") {
			startTrackRacing();
		} else if (!isTrackRacing.value && trackRacingSignalR.state === "Connected") {
			stopTrackRacing();
		}
	});

	const checkSignalRConnectionStatus = (id: "Sports" | "TrackRacing") => {
		return new Promise((resolve) => {
			const interval = setInterval(() => {
				if ((id === "Sports" && sportsSignalR.state === "Connected") || (id === "TrackRacing" && trackRacingSignalR.state === "Connected")) {
					resolve(true);
					clearInterval(interval);
				} else {
					// Repeat because signalr is not connected
				}
			}, 200);
		});
	};

	return {
		provide: {
			sportsSignalR,
			checkSignalRConnectionStatus,
			trackRacingSignalR,
		},
	};
});
